import { Box } from '@mui/material'
import React from 'react'
import CircleIcon from '@mui/icons-material/Circle';
import useStyles from './styles';

interface Props {
  boxSize: number;
  circleSize: number;
  color: string;
}

export default function Circle({ boxSize = 20, circleSize = 12, color }: Props) {
  const styles = useStyles();

  return (
    <Box
      className={styles.circleBox}
      sx={{
        width: boxSize,
      }}
    >
      <CircleIcon sx={{
        fontSize: circleSize,
        color: color,
      }} />
    </Box>
  )
}
